import { defaultState } from '../reducers/promoDetails';
import { IPromoDetailsState } from '../types/redux/promoDetails';
import { IPromosState } from '../types/redux/promos';

export const mapPromoDetails = ({
  promoId,
  promos,
}: {
  promoId?: string;
  promos: IPromosState;
}): IPromoDetailsState => {
  if (!promoId) {
    return defaultState;
  }

  const hasThisPromoId = promos.allIds.includes(promoId);

  if (hasThisPromoId) {
    return {
      isOpenModal: true,
      currentPromoId: promoId,
    };
  }

  return defaultState;
};
